export enum InsightSeverity {
	NEEDS_ATTENTION = 'needs_attention',
	POSITIVE = 'positive',
	WORTH_MONITORING = 'worth_monitoring',
}
